import StepActorChoice from "@Front/Components/Layouts/Login/StepActorChoice";
import StepCustomerOfficeChoice from "@Front/Components/Layouts/Login/StepCustomerOfficeChoice";
import StepCustomerTargetChoice from "@Front/Components/Layouts/Login/StepCustomerTargetChoice";
import { LoginStep, useLoginController } from "@Front/Components/Layouts/Login/hooks/useLoginController";
import { loginCredentialStepPanel } from "@Front/Components/Layouts/Login/components/loginCredentialStepPanel";

type Controller = ReturnType<typeof useLoginController>;

function loginDisambiguationStepPanel(step: LoginStep, controller: Controller): React.JSX.Element | null {
	if (step === LoginStep.ACTOR_CHOICE) {
		return (
			<StepActorChoice
				onChooseCustomer={() => void controller.onChooseCustomerActor()}
				onChooseThirdParty={controller.onChooseThirdPartyActor}
				isSubmitting={controller.disambiguationBusy}
			/>
		);
	}
	if (step === LoginStep.CUSTOMER_OFFICE_CHOICE) {
		return (
			<StepCustomerOfficeChoice
				offices={controller.customerOfficeChoiceEntries}
				onSelectOffice={(officeUid) => void controller.onSelectCustomerOffice(officeUid)}
				isSubmitting={controller.disambiguationBusy}
			/>
		);
	}
	if (step === LoginStep.CUSTOMER_TARGET_CHOICE) {
		return controller.loginCandidates ? (
			<StepCustomerTargetChoice
				candidates={
					controller.customerTargetChoiceCandidates ?? controller.loginCandidates.customerCandidates
				}
				subtitle={controller.customerTargetChoiceSubtitle}
				onSelect={(row) => void controller.onSelectCustomerLoginTarget(row)}
				isSubmitting={controller.disambiguationBusy}
			/>
		) : null;
	}
	return null;
}

export function loginStepPanelFor(step: LoginStep, controller: Controller): React.JSX.Element | null {
	const disambiguation = loginDisambiguationStepPanel(step, controller);
	if (disambiguation !== null) {
		return disambiguation;
	}
	return loginCredentialStepPanel(step, controller);
}
